// extracted by mini-css-extract-plugin
module.exports = {"cloud_sync":"FJCloudSyncButton_cloud_sync__1PyQ8"};